import { DSReactExamples } from "@spscommerce/ds-shared";
import { code } from "@spscommerce/utils";

export const SpsModalExamples: DSReactExamples = {
    kinds: {
        label: "Kinds",
        examples: {
            info: {
                react: code`
                    function Component() {
                        const [showModal, setShowModal] = React.useState(false);

                        return <>
                            <SpsButton onClick={() => setShowModal(true)}>
                                Show Info (Default) Modal
                            </SpsButton>
                            {showModal && (
                                <SpsModalV2
                                    kind={ModalKind.INFO}
                                    onClose={() => setShowModal(false)}
                                >
                                    <div className="sps-text-semibold mb-1">Optional Headline</div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </SpsModalV2>
                            )}
                        </>;
                    }
                `
            },
            success: {
                react: code`
                    function Component() {
                        const [showModal, setShowModal] = React.useState(false);

                        return <>
                            <SpsButton onClick={() => setShowModal(true)}>
                                Show Success Modal
                            </SpsButton>
                            {showModal && (
                                <SpsModalV2
                                    kind={ModalKind.SUCCESS}
                                    onClose={() => setShowModal(false)}
                                >
                                    <div className="sps-text-semibold mb-1">Optional Headline</div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </SpsModalV2>
                            )}
                        </>;
                    }
                `
            },
            warning: {
                react: code`
                    function Component() {
                        const [showModal, setShowModal] = React.useState(false);

                        return <>
                            <SpsButton onClick={() => setShowModal(true)}>
                                Show Warning Modal
                            </SpsButton>
                            {showModal && (
                                <SpsModalV2
                                    kind={ModalKind.WARNING}
                                    onClose={() => setShowModal(false)}
                                >
                                    <div className="sps-text-semibold mb-1">Optional Headline</div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </SpsModalV2>
                            )}
                        </>;
                    }
                `
            },
            seriousWarning: {
                react: code`
                    function Component() {
                        const [showModal, setShowModal] = React.useState(false);

                        return <>
                            <SpsButton onClick={() => setShowModal(true)}>
                                Show Serious Warning Modal
                            </SpsButton>
                            {showModal && (
                                <SpsModalV2
                                    kind={ModalKind.SERIOUS_WARNING}
                                    onClose={() => setShowModal(false)}
                                >
                                    <div className="sps-text-semibold mb-1">Optional Headline</div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </SpsModalV2>
                            )}
                        </>;
                    }
                `
            },
            general: {
                react: code`
                    function Component() {
                        const [showModal, setShowModal] = React.useState(false);

                        return <>
                            <SpsButton onClick={() => setShowModal(true)}>
                                Show General Modal
                            </SpsButton>
                            {showModal && (
                                <SpsModalV2
                                    kind={ModalKind.GENERAL}
                                    onClose={() => setShowModal(false)}
                                >
                                    <div className="sps-text-semibold mb-1">Optional Headline</div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </SpsModalV2>
                            )}
                        </>;
                    }
                `
            },
        }
    },
    sizes: {
        label: "Sizes",
        examples: {
            small: {
                react: code`
                    function Component() {
                        const [showModal, setShowModal] = React.useState(false);

                        return <>
                            <SpsButton onClick={() => setShowModal(true)}>
                                Show Small (Default) Modal
                            </SpsButton>
                            {showModal && (
                                <SpsModalV2
                                    size={ModalSize.SMALL}
                                    onClose={() => setShowModal(false)}
                                >
                                    <div className="sps-text-semibold mb-1">Optional Headline</div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </SpsModalV2>
                            )}
                        </>;
                    }
                `
            },
            medium: {
                react: code`
                    function Component() {
                        const [showModal, setShowModal] = React.useState(false);

                        return <>
                            <SpsButton onClick={() => setShowModal(true)}>
                                Show Medium Modal
                            </SpsButton>
                            {showModal && (
                                <SpsModalV2
                                    size={ModalSize.MEDIUM}
                                    onClose={() => setShowModal(false)}
                                >
                                    <div className="sps-text-semibold mb-1">Optional Headline</div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </SpsModalV2>
                            )}
                        </>;
                    }
                `
            },
            large: {
                react: code`
                    function Component() {
                        const [showModal, setShowModal] = React.useState(false);

                        return <>
                            <SpsButton onClick={() => setShowModal(true)}>
                                Show Large Modal
                            </SpsButton>
                            {showModal && (
                                <SpsModalV2
                                    size={ModalSize.LARGE}
                                    onClose={() => setShowModal(false)}
                                >
                                    <div className="sps-text-semibold mb-1">Optional Headline</div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </SpsModalV2>
                            )}
                        </>;
                    }
                `
            },
        }
    },
    customization: {
        label: "Customization",
        examples: {
            title: {
                description: "<p>Custom title</p>",
                react: code`
                    function Component() {
                        const [showModal, setShowModal] = React.useState(false);

                        return <>
                            <SpsButton onClick={() => setShowModal(true)}>
                                Show Modal
                            </SpsButton>
                            {showModal && (
                                <SpsModalV2 title="Custom Modal Title"
                                    onClose={() => setShowModal(false)}
                                >
                                    <div className="sps-text-semibold mb-1">Optional Headline</div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                </SpsModalV2>
                            )}
                        </>;
                    }
                `
            },
            buttons: {
                description: "<p>Custom buttons</p>",
                react: code`
                    function Component() {
                        const [showModal, setShowModal] = React.useState(false);

                        function secondaryAction() {
                            console.log("Secondary action invoked");
                            setShowModal(false);
                        }

                        function primaryAction() {
                            console.log("Primary action invoked");
                            setShowModal(false);
                        }

                        return <>
                            <SpsButton onClick={() => setShowModal(true)}>
                                Show Modal
                            </SpsButton>
                            {showModal && (
                                <SpsModalV2 onClose={() => setShowModal(false)}>
                                    <div className="sps-text-semibold mb-1">Optional Headline</div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                    <SpsModalV2Footer>
                                        <SpsButton onClick={secondaryAction}>Secondary Action</SpsButton>
                                        <SpsButton kind={ButtonKind.KEY} onClick={primaryAction}>Primary Action</SpsButton>
                                    </SpsModalV2Footer>
                                </SpsModalV2>
                            )}
                        </>;
                    }
                `
            },
        }
    },
    notCancelable: {
        label: "Non-Cancelable",
        examples: {
            buttons: {
                description: code`
                    <p>If you provide custom buttons but do <i>not</i> provide onClose, then the 'x' button
                    in the titlebar will not be rendered, and pressing ESC will do nothing. The user will be
                    forced to click one of the buttons you provide.</p>
                `,
                react: code`
                    function Component() {
                        const [showModal, setShowModal] = React.useState(false);

                        function secondaryAction() {
                            console.log("Secondary action invoked");
                            setShowModal(false);
                        }

                        function primaryAction() {
                            console.log("Primary action invoked");
                            setShowModal(false);
                        }

                        return <>
                            <SpsButton onClick={() => setShowModal(true)}>
                                Show Modal
                            </SpsButton>
                            {showModal && (
                                <SpsModalV2>
                                    <div className="sps-text-semibold mb-1">Optional Headline</div>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                    <SpsModalV2Footer>
                                        <SpsButton onClick={secondaryAction}>Secondary Action</SpsButton>
                                        <SpsButton kind={ButtonKind.KEY} onClick={primaryAction}>Primary Action</SpsButton>
                                    </SpsModalV2Footer>
                                </SpsModalV2>
                            )}
                        </>;
                    }
                `
            },
        }
    }
};
